import * as React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';



export default function CheckboxList(props) {

  const {onChangeValues,ProcedureTypeDropDown, selectedValue}=props
const [index,setIndex]=React.useState(0)
  return (
    <List sx={{ bgcolor: 'background.paper' }}
    style={{
        maxHeight:200,
        textAlign:"justify",
        overflowY:'scroll',
        overflowX:"hidden",
        border:"1px solid black",
        paddingLeft:"0px",
        minWidth:'100%' ,
      }}
      className="uniquelehdos has-scrollbar12"
    >
      {ProcedureTypeDropDown&&ProcedureTypeDropDown.length&&ProcedureTypeDropDown.length>0?ProcedureTypeDropDown.map((value,i) => {
        const labelId = `checkbox-list-label-${value}`;
        
        if(i==index){
            return (
                <ListItem
                  key={value}
                 style={{fontSize:"12px",fontWeight:"400",height:"16px",cursor: "pointer",
                 whiteSpace:"nowrap",
                 paddingLeft:"1px"}}
                 className="same-font-family"
                 selected={selectedValue == value}                 
                 onClick={()=>{
                  onChangeValues(null,"procedurTypeSelectedOption",value)
               }}
                >
      {value}
                </ListItem>
              );
        }
        else{
            return (
                <ListItem
                  key={value}                 
                 onClick={()=>{
                    setIndex(i)
                    onChangeValues(null,"procedurTypeSelectedOption",value)
                 }}
                  style={{fontSize:"12px",fontWeight:"400",height:"16px",width:"99%",cursor: "pointer"
                ,whiteSpace:"nowrap",
                paddingLeft:"1px"}}
               className="same-font-family"
               selected={selectedValue == value}
               >
{value}
      
                </ListItem>
              );
        }
      }):null}
    </List>
  );
}
